import React, { useMemo } from "react";
import PropTypes from "prop-types";

const MessageButtons = ({ actions = [], quickReplies = [] }) => {
  const renderButtons = useMemo(() => {
    let buttons = [];

    if (actions.length > 0) {
      buttons = [
        ...buttons,
        ...actions
          .filter((item) => item.text)
          .map((item, index) => (
            <button
              key={`actions-${index}`}
              className="border-none flex-1 bg-blue-500 text-white text-sm py-2 px-3 rounded-lg"
            >
              {item.text}
            </button>
          )),
      ];
    }

    if (quickReplies.length > 0) {
      buttons = [
        ...buttons,
        ...quickReplies
          .filter((item) => item.text)
          .map((item, index) => (
            <button
              key={`quickReplies-${index}`}
              className="border-none flex-1 bg-gray-300 text-gray-700 text-sm py-2 px-3 rounded-lg"
            >
              {item.text}
            </button>
          )),
      ];
    }

    if (buttons.length === 0) return null;

    return buttons;
  }, [actions, quickReplies]);

  return <div className="grid gap-2 grid-cols-1">{renderButtons}</div>;
};

MessageButtons.propTypes = {
  actions: PropTypes.array,
  quickReplies: PropTypes.array,
};

export default MessageButtons;
